import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { FlexColumn, FlexRow } from "./common.styles";
import { LightText } from "./HXMobilePage.styles";
import { HXMobileButton } from "./HXButton";
import Lock from "@mui/icons-material/Lock";
export const SmartLinkSection = styled(FlexColumn) `
    gap: 12px;
    align-self: stretch;
`;
export const SmartLinkSectionLabel = styled.label `
    font-family: inherit;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: 100%;
    letter-spacing: 0.15px;
    color: ${colors.black_main};
`;
export const SmartLinkTextFieldWrapper = styled(FlexColumn) `
    gap: 4px;
    align-self: stretch;
`;
export const SmartLinkOptionLabelContent = styled(FlexColumn) `
    margin-left: 8px;
    gap: 2px;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
    text-align: left;
`;
export const SmartLinkOptionTitle = styled.span `
    font-size: ${fontSizes.SMALL};
    line-height: 100%;
    color: ${colors.black_light};
    text-align: left;
`;
export const SmartLinkOptionDescription = styled(LightText) `
    font-size: ${fontSizes.SMALL};
    line-height: 100%;
    color: ${colors.black_lighter};
    text-align: left;
`;
export const SmartLinkPrimaryButton = styled(HXMobileButton).attrs({ variant: "contained" }) `
    width: 100%;
    height: 56px;
    border-radius: 999px;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    letter-spacing: 0.15px;
`;
export const SmartLinkSecondaryButton = styled(HXMobileButton).attrs({ variant: "text" }) `
    width: 100%;
    height: 56px;
    border-radius: 999px;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    letter-spacing: 0.15px;
    color: ${colors.navy_main};
`;
export const SmartLinkSelectDataTypesHeader = styled(FlexRow) `
    gap: 8px;
    align-items: center;
    align-self: stretch;
    justify-content: space-between;
`;
export const SmartLinkSelectDataTypesLabel = styled.span `
    text-align: left;
    font-size: ${fontSizes.SMALL};
    line-height: 100%;
    color: ${colors.black_lighter};
    flex: 1 0 0;
`;
export const SmartLinkClearLink = styled.button `
    font-family: inherit;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
    color: ${colors.blue_main};
    text-decoration: underline;
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px 8px;
    border-radius: 999px;

    @media (hover: hover) {
        &:hover {
            text-decoration: underline;
        }
    }
`;
export const SmartLinkDataTypesList = styled(FlexColumn) `
    gap: 8px;
    align-self: stretch;
`;
export const SmartLinkDemographicsRow = styled.div `
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 12px 12px 12px 16px;
    border-radius: 12px;
    border: 1px solid ${colors.blue_30};
    background: ${colors.blue_10};
    opacity: 0.6;
    pointer-events: none;
    min-height: 56px;
    box-sizing: border-box;
    align-self: stretch;
`;
export const SmartLinkDemographicsLabel = styled(FlexColumn) `
    gap: 2px;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
    text-align: left;
`;
export const SmartLinkDemographicsTitle = styled.span `
    font-size: ${fontSizes.SMALL};
    line-height: 100%;
    color: ${colors.black_light};
    text-align: left;
`;
export const SmartLinkDemographicsHint = styled.span `
    font-size: ${fontSizes.SMALL};
    line-height: 100%;
    color: ${colors.black_lighter};
    text-align: left;
`;
export const SmartLinkLockIconContainer = styled(FlexRow) `
    align-self: center;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 2px solid ${colors.navy_main};
    background: ${colors.navy_main};
`;
export const SmartLinkLockIcon = styled(Lock) `
    width: 12px;
    height: 12px;
    color: ${colors.white_main};
`;
